import { DeleteAccountForm } from '@/components/auth/DeleteAccountForm';

export function DeleteAccount() {
  return (
    <div className="container py-10">
      <DeleteAccountForm />
    </div>
  );
} 